// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__34uoo","choiceBoxes":"toolbarselects_choiceBoxes__d5cnI","simpleField":"toolbarselects_simpleField__SoX2_"};